import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { ESearchType } from '../enums/search-type';

type State = {
  query: string;
  type: ESearchType | null;
};

type Action = {
  setQuery: (query: string) => void;
  setType: (type: ESearchType) => void;
  resetState: () => void;
};

export const useGlobalSearchStore = create<State & Action>()(
  immer((set) => ({
    query: '',
    type: null,
    setQuery: (query) => {
      set((state) => {
        state.query = query;
      });
    },
    setType: (type) => {
      set((state) => {
        state.type = type;
      });
    },
    resetState: () => {
      set((state) => {
        state.query = '';
        state.type = null;
      });
    },
  }))
);
